// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 156 ? "e99863e0" : chunkId) + "." + {"156":"9f6b5ae518c95ad0","938":"9210bec36fc2e971"}[chunkId] + ".js";
};